import { z } from 'zod';
import { USER_DISPLAY_NAME_MAX } from '../constants/limits.js';
import { PasswordSchema } from './auth.schema.js';
export const UserRoleSchema = z.enum(['admin', 'user']);
export const CreateUserRequestSchema = z.object({
    email: z.string().email().max(320),
    password: PasswordSchema,
    displayName: z.string().min(1).max(USER_DISPLAY_NAME_MAX),
    role: UserRoleSchema,
});
export const UpdateUserRequestSchema = z
    .object({
    displayName: z.string().min(1).max(USER_DISPLAY_NAME_MAX).optional(),
    password: PasswordSchema.optional(),
    role: UserRoleSchema.optional(),
    isActive: z.boolean().optional(),
})
    .refine((data) => Object.keys(data).length > 0, {
    message: 'At least one field must be provided',
});
export const ListUsersQuerySchema = z.object({
    search: z.string().max(200).optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
export const UserIdParamSchema = z.object({
    id: z.string().uuid(),
});
//# sourceMappingURL=user.schema.js.map